import { render, staticRenderFns } from "./SendSpeakerMessageDialog.vue?vue&type=template&id=6b7c2304&"
import script from "./SendSpeakerMessageDialog.vue?vue&type=script&lang=js&"
export * from "./SendSpeakerMessageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports